import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOTIF } from 'services/glass-management/otif';

export const fetchOTIF = createAsyncThunk('glass/otif/fetch', async (filters) => {
    const res = await getOTIF(filters.start, filters.end);
    return { data: res };
});

export const otifSlice = createSlice({
    name: 'glassOtif',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchOTIF.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOTIF.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchOTIF.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load OTIF';
                state.data = null;
            });
    }
});

export default otifSlice.reducer;
